import React from 'react';

import { BrowserRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { setDefaultOptions } from 'date-fns';
import { enUS, ko } from 'date-fns/locale';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

import { GlobalStyle } from './styles/globalStyle';
import { ThemeProvider } from 'styled-components';
import { MuiTheme } from './styles/muiTheme';
import theme from './styles/theme';

import MainRoute from '@/MainRoute';

function App() {
  const { i18n } = useTranslation();
  setDefaultOptions({ locale: i18n.language.startsWith('ko') ? ko : enUS });

  return (
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <StyledEngineProvider injectFirst>
        <MuiThemeProvider theme={MuiTheme}>
          <CssBaseline enableColorScheme />
          <GlobalStyle />
          <ThemeProvider theme={theme}>
            <MainRoute />
          </ThemeProvider>
        </MuiThemeProvider>
      </StyledEngineProvider>
    </BrowserRouter>
  );
}

export default App;
